import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1599696848652-f0ff23bc911f?auto=format&fit=crop&w=2000&q=80";

const Line = ({ children, delay }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0.2]);

  return (
    <section ref={ref} id="top" className="relative min-h-screen flex items-end overflow-hidden" data-testid="hero-section">
      <motion.div className="absolute inset-0" style={{ y }}>
        <motion.img
          src={HERO_IMG}
          alt="İnegöl Mobilya Mardin — premium yaşam alanı"
          className="w-full h-full object-cover"
          initial={{ scale: 1.15 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
          data-testid="hero-image"
        />
        <div className="absolute inset-0 bg-black/30" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-32">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="text-xs font-semibold tracking-[0.3em] uppercase text-stone-200 mb-6"
          data-testid="hero-eyebrow"
        >
          El İşçiliği — Est. 1998
        </motion.p>
        <h1 className="font-serif font-light tracking-tighter leading-[0.95] text-stone-50 text-5xl sm:text-6xl lg:text-8xl" data-testid="hero-title">
          <Line delay={0.3}>Yaşam alanınız için</Line>
          <Line delay={0.45}>
            <em className="text-beige">zamansız</em> tasarımlar
          </Line>
          <Line delay={0.6}>doğal ahşapla.</Line>
        </h1>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6"
        >
          <a
            href="#koleksiyon"
            data-testid="hero-cta-button"
            className="inline-flex items-center gap-3 bg-stone-50 text-stone-900 px-8 py-4 text-xs font-semibold tracking-[0.2em] uppercase hover:bg-beige transition-colors duration-300"
          >
            Koleksiyonu Keşfet
            <ArrowDown size={14} />
          </a>
          <p className="text-stone-200 text-sm font-light max-w-xs leading-relaxed">
            Koltuktan yatağa, her parça ustalıkla ve özenle üretilir.
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
};
